import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {

    var thisElement = this.element

    const stars = [...thisElement.querySelectorAll("i")]

    const starClassActive = "bi bi-star-fill";
    const starClassInactive = "bi bi-star";
    const starsLength = stars.length;
    let order;

    stars.map((star) => {
      star.onclick = () => {
        order = stars.indexOf(star);

        thisElement.querySelector('#reference_rating').value = (order + 1)
  
        // all inactive
        stars.forEach(s => { s.className = starClassInactive })

        // set active
        stars.forEach((s, index) => { 
          if (index <= order) s.className = starClassActive
        })

      }
    })
  }
}
